export function getIdentityDependantTableStateKey(keyCandidate) {
    const identityId = window.infinito.vao.controller.storageHelper.getIdentitiesId();
    if (!identityId || typeof identityId !== 'string' || identityId.length === 0) {
        return null;
    }
    return `${identityId}_${keyCandidate}`;
}
